import {PluginCommand as command_evaluate} from "../src/commands/evaluate"

export const commands = {
  "evaluate": {PluginCommand: command_evaluate},
}